/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */

import Vue from 'vue';
import {default as SvgIcons} from '../../../components/payment/assets/icons/svg-icons'
import transactions from "../../../components/payment/features/Transactions";

const state = {
  cardList: [],
  showForm: false,
  error: null,
  showWarningModal: {
    show: false,
    header: '',
    body: ''
  },
  inProgress: false,
  isLoadingTransactions: false,
  isExtendingLimitLoading: false,
  regSuccessMessage: '',
  regErrorMessage: '',
  showConfirmationModal: false,
  transactions: {
    data: [],
    meta: {}
  },
  dates: {
    months: {
      prev: -1,
      cur: -1,
      next: -1
    },
    years: {
      prev: 0,
      cur: 0,
      next: 0
    },
    daysInCurMonth: 0
  }
};

const getters = {
  cardList: state => state.cardList,
  showForm: state => state.showForm,
  error: state => state.error,
  showWarningModal: state => state.showWarningModal,
  inProgress: state => state.inProgress,
  regSuccessMessage: state => state.regSuccessMessage,
  regErrorMessage: state => state.regErrorMessage,
  showConfirmationModal: state => state.showConfirmationModal,
  transactions: state => state.transactions,
  isLoadingTransactions: state => state.isLoadingTransactions,
  isExtendingLimitLoading: state => state.isExtendingLimitLoading,
  dates: state => state.dates
}

const mutations = {
  ['show-form'](state, payload) {
    state.showForm = payload
  },
  ['set-card-list'](state, payload) {
    state.cardList = payload
  },
  ['show-warning-modal'](state, payload) {
    state.showWarningModal = payload
  },
  ['set-in-progress-status'](state, payload) {
    state.inProgress = payload
  },
  ['set-reg-result-message'](state, payload) {
    if (payload.success) {
      state.regSuccessMessage = payload.message
    } else {
      state.regErrorMessage = payload.message
    }
  },
  ['show-confirmation-modal'](state, payload) {
    state.showConfirmationModal = payload
  },
  ['store-transactions'](state, payload) {
    state.transactions.data = payload.data
    state.transactions.meta = payload.meta
  },
  ['set-is-loading-transactions'](state, status) {
    state.isLoadingTransactions = status
  },
  ['set-is-extending-limit-loading'](state, status) {
    state.isExtendingLimitLoading = status
  },
  ['set-dates'](state, payload) {
    state.dates.months = payload.months
    state.dates.years = payload.years
    state.dates.daysInCurMonth = payload.daysInCurMonth
  }
}

const actions = {
  setDates({commit}, payload) {
    commit('set-dates', payload)
  },
  fetchTransactions({commit}, payload) {
    if (payload.page === 1) {
      commit('set-is-loading-transactions', true)
    } else {
      commit('set-is-extending-limit-loading', true)
    }
    Vue.http.get(`${process.env.BACKEND_API_URL}api/payment/transactions?month=${payload.month}&year=${payload.year}&page=${payload.page}`)
      .then(response => {
        if (response.body.data && response.body.meta) {
          commit('store-transactions', {
            data: payload.page > 1 ? [...state.transactions.data, ...response.body.data] : response.body.data,
            meta: response.body.meta
          })
        }
        if (payload.page === 1) {
          commit('set-is-loading-transactions', false)
        } else {
          commit('set-is-extending-limit-loading', false)
        }
      }).catch(error => {
      if (payload.page === 1) {
        commit('set-is-loading-transactions', false)
      } else {
        commit('set-is-extending-limit-loading', false)
      }
      console.log(error)
    })
  },
  fetchUserCardList({commit}) {
    commit('set-in-progress-status', true)
    Vue.http.get(`${process.env.BACKEND_API_URL}api/payment/cards`)
      .then((response) => {

        // set card icon, if exists
        for (let item in response.body.data) {
          let cardIcon = ''
          let issuer = response.body.data[item].issuer.toLowerCase()
          if (SvgIcons[issuer] !== undefined) {
            cardIcon = SvgIcons[issuer]
          }
          response.body.data[item].icon = cardIcon
        }

        commit('set-card-list', response.body.data);
        commit('set-in-progress-status', false)
      }).catch((response) => {
      console.log(response.status, response.statusText)
    }).finally(() => {
      commit('set-in-progress-status', false)
    });
  },

  showForm({commit}, payload) {
    commit('show-form', payload)
  },

  showWarning({commit}, payload) {
    commit('show-warning-modal', {
      show: payload.status,
      header: payload.header ? payload.header : '',
      body: payload.body ? payload.body : '',
    })
  },

  getTransactionIdentifier({commit}, payload) {
    return Vue.http.get(`${process.env.BACKEND_API_URL}payment/cards/register?`
      + `pan=${payload.cardNumber}&`
      + `expiry_date=${payload.cardExpiry}&`
      + `cvc=${payload.cardCvc}&`
      + `name=${payload.cardHolderName}&`
      + `return_url=${process.env.BASE_URL}payment/register/result`)
      .then((response) => {
        if (response.data.transaction_id) {
          return response.data.transaction_id
        }
        return null
      }).catch((response) => {
          if (response.status === 422) {
            let errorData = {
              show: true,
              header: 'payment.card_register_error',
              body: ''
            }
            Object.keys(response.body.errors).forEach(key => {
              errorData.body = 'payment.' + response.body.errors[key][0].replaceAll('.', '_')
            })
            commit('show-warning-modal', errorData)
          }
        }
      )
  },

  storeCard({commit}, cardData) {
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/payment/cards`, {
      transaction_id: cardData.transactionId
    }).then(response => {
      return response.status === 204;
    }).catch((response) => {
      commit('show-warning-modal', {
        show: true,
        header: 'payment.card_register_error'
      })
      return false
    })
  },

  setInProgress({commit}, payload) {
    commit('set-in-progress-status', payload)
  },

  setDefault({commit}, payload) {
    commit('set-in-progress-status', true)
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/payment/cards/` + payload.card_id + `/set_default`)
      .then(response => {
        commit('set-in-progress-status', false)
        return true
      }).catch(response => {
        return false
      }).finally(() => {
        commit('set-in-progress-status', false)
      })
  },

  removeCard({commit}, payload) {
    commit('set-in-progress-status', true)
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/payment/cards/` + payload.card_id)
      .then(response => {
        return true
      }).catch(response => {
        return false
      }).finally(() => {
        commit('show-confirmation-modal', false)
        commit('set-in-progress-status', false)
      })
  },

  setRegResultMessage({commit}, payload) {
    commit('set-reg-result-message', payload)
  },

  setShowConformationModal({commit}, status) {
    commit('show-confirmation-modal', status)
  }

}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/payment/cards.js